module.exports = __webpack_public_path__ + "static/media/sygnet.d397120e.gif";